import React, { useContext, useState } from "react";
import "./index.scss";
import CustomIndiaMap from "./custom-india-map";
import { Typography, IconButton, Box } from "@mui/material";
import SplitIcon from "@mui/icons-material/VerticalSplit";
import CustomDashboardFilters from "../../components/custom-dashboard-filters";
import { FINANCIAL_YEAR } from "./utils";
import { TICKET_STATUS } from "../ticket-filters/config";
import AppContext from "../../utils/context";
import { USER_ROLES } from "../../utils/constants";
import { convertCamelCaseToDisplayText } from "../../utils";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const IndiaMap = ({
  data = {},
  title,
  isModalOpen = false,
  loadStateData,
  selectedFilters = [],
  setSelectedFilters,
  isOverview = false,
}) => {
  const [splitView, setSplitView] = useState(false);
  const [splitScreenData, setSplitScreenData] = useState(data);
  const [oemOrgList, setOemOrgList] = useState([]);
  const [defectCodeList, setDefectCodeList] = useState([]);
  const [complaintCodes, setComplaintCodes] = useState([]);
  const [serviceEngineers, setServiceEngineers] = useState([]);
  const [engineModel, setEngineModel] = useState([]);
  const [ticketStages, setTicketStages] = useState([]);
  const [listNumbers, setListNumbers] = useState([]);
  const { userDetails = {} } = useContext(AppContext);
  const {
    setEngineReplacementDashboardFilter,
    engineReplacementDashboardFilter = {},
    setOverviewDashboardFilter,
  } = useContext(AppContext);
  const filters = () => {
    const list = [
      {
        label: "Financial Year",
        type: "autocomplete",
        options: FINANCIAL_YEAR,
        name: "financialYear",
      },

      {
        label: "Select Defect",
        type: "autocomplete",
        options: defectCodeList || [],
        name: "defectCode",
      },
      {
        label: "Select Complaint Code",
        type: "autocomplete",
        options: complaintCodes || [],
        name: "complaintCode",
      },
      {
        label: "Select Service Engineer",
        type: "autocomplete",
        options: serviceEngineers || [],
        name: "serviceEngineer",
      },
      {
        label: "Select Ticket Stage",
        type: "autocomplete",
        options: ticketStages || [],
        name: "stage",
      },
      {
        label: "Select Ticket Status",
        type: "autocomplete",
        options: TICKET_STATUS || [],
        name: "status",
      },
      {
        label: "Select Engine Model",
        type: "autocomplete",
        options: engineModel || [],
        name: "engineModal",
      },
      {
        label: "Select List Number",
        type: "autocomplete",
        options: listNumbers || [],
        name: "listNumber",
      },
      {
        label: "Select Date",
        type: "dateRange",
        name: "date",
      },
    ];

    if (userDetails.role !== USER_ROLES.OEM) {
      list.push({
        label: "Select Oem",
        type: "autocomplete",
        options: oemOrgList || [],
        name: "oemOrg",
      });
    }
    return list;
  };
  const updateOrgList = (data) => {
    setOemOrgList(data);
  };
  const handleApplyFilters = (filters, isSplitFilter) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = [filters[key].value];
        } else {
          if (key === "date") {
            const dateSplit = filters[key]?.split("to");
            payload["startDate"] = dateSplit[0]?.trim();
            payload["endDate"] = dateSplit[1]?.trim();
          } else {
            payload[key] = [filters[key]];
          }
        }
      }
      if (isOverview) {
        setOverviewDashboardFilter((prevVal) => ({
          ...payload,
        }));
      } else {
        setEngineReplacementDashboardFilter((prevVal) => ({
          ...payload,
        }));
      }

      // if (isSplitFilter) {
      //   loadStateData(
      //     {
      //       ...payload,
      //     },
      //     setSplitScreenData
      //   );
      // } else {
      //   loadStateData({
      //     ...payload,
      //   });
      //   setEngineReplacementDashboardFilter((prevVal) => ({
      //     ...prevVal,
      //     ...payload,
      //   }));
      // }
    } else {
      if (isSplitFilter) {
        loadStateData({}, setSplitScreenData);
      } else {
        loadStateData({});
        if (isOverview) {
          setOverviewDashboardFilter({});
        } else {
          setEngineReplacementDashboardFilter({});
        }
      }
    }
  };
  const handleRemoveFilter = (type) => {
    const updatedFilters = selectedFilters.filter(
      (filter) => filter.type !== type
    );
    setSelectedFilters(updatedFilters);
    const filtersObj = updatedFilters.reduce((acc, filter) => {
      acc[filter.type] = filter.value;
      return acc;
    }, {});
    handleApplyFilters(filtersObj);
  };

  return (
    <div className="india-map-card-container">
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6">{title}</Typography>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <div onClick={(event) => event.stopPropagation()}>
            {!splitView && (
              <CustomDashboardFilters
                filters={filters()}
                onApplyFilters={handleApplyFilters}
                updateOrgList={updateOrgList}
                setDefectCodeList={setDefectCodeList}
                setComplaintCodes={setComplaintCodes}
                setServiceEngineers={setServiceEngineers}
                setTicketStages={setTicketStages}
                setEngineModel={setEngineModel}
                setListNumbers={setListNumbers}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
              />
            )}
          </div>
          {isModalOpen && !splitView && (
            <IconButton onClick={() => setSplitView(true)} title="Split View">
              <SplitIcon />
            </IconButton>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          mb: 2,
          gridGap: "5px",
          justifyContent: "flex-end",
        }}
      >
        {selectedFilters?.map((filter, index) => (
          <div
            key={index}
            className={`chip-com-con ${
              (index + 1) % 2 ? "purple-bg" : "orange-bg"
            }`}
          >
            <p>
              {`${convertCamelCaseToDisplayText(filter.type)}: ${
                typeof filter.value === "object"
                  ? filter?.value?.label
                  : filter.value
              }`}
            </p>
            <CloseOutlinedIcon
              onClick={() => {
                handleRemoveFilter(filter.type);
              }}
              fontSize="small"
              sx={{ ml: 1, cursor: "pointer" }}
            />
          </div>
        ))}
      </Box>

      <div
        className={`india-map-container ${splitView ? "split-view" : ""}`}
        style={{ display: splitView ? "flex" : "block", gap: "16px" }}
      >
        <div className="map-section">
          {splitView && (
            <div className="india-filter-con">
              <CustomDashboardFilters
                filters={filters()}
                onApplyFilters={handleApplyFilters}
                updateOrgList={updateOrgList}
                setDefectCodeList={setDefectCodeList}
                setComplaintCodes={setComplaintCodes}
                setServiceEngineers={setServiceEngineers}
                setTicketStages={setTicketStages}
                setEngineModel={setEngineModel}
                setListNumbers={setListNumbers}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
              />
            </div>
          )}
          <CustomIndiaMap data={data} isOverview={isOverview} />
        </div>
        {splitView && (
          <div className="map-section">
            <div className="india-filter-con">
              <CustomDashboardFilters
                filters={filters()}
                onApplyFilters={handleApplyFilters}
                updateOrgList={updateOrgList}
                setDefectCodeList={setDefectCodeList}
                setComplaintCodes={setComplaintCodes}
                setServiceEngineers={setServiceEngineers}
                setTicketStages={setTicketStages}
                setEngineModel={setEngineModel}
                setListNumbers={setListNumbers}
                isSplitFilter={true}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
              />
            </div>
            <CustomIndiaMap data={splitScreenData} isOverview={isOverview} />
          </div>
        )}
      </div>
    </div>
  );
};

export default IndiaMap;
